import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaThumbsUp } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import Alert from '../../components/Alert';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelLocal() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [locais, setLocais] = useState([]);
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/local',
            token: token,
            params: { ...filtro, situacaoRegistro: "ativo" },
            signal: controllerRef.current.signal
        }).then(response => {
            setLocais(response.data.data);
            setSelectedIds(new Set());
            setPage(1);
            setBuscando(false);
        }).catch((err) => {
            if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
            setBuscando(false);
        });
    };

    useEffect(() => {
        document.querySelector("#nome")?.focus();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const excluirSelecionado = (rowId) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/local/' + rowId,
                        token: token,
                    }).then(() => {
                        buscar();
                    }).catch(() => {});
                }
            }
        });
    };

    const total = locais.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = locais.slice((page - 1) * pageSize, page * pageSize);
    const podeExcluir = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil);
    const selectedArr = [...selectedIds];

    const toggleSelect = (rowId) => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
    };

    const toggleAll = () => {
        if (paginados.length > 0 && selectedIds.size === paginados.length) {
            setSelectedIds(new Set());
        } else {
            setSelectedIds(new Set(paginados.map(r => r.id)));
        }
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Locais</h1>
                    </div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroLocal" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Novo Local
                        </Link>
                    </div>
                </div>

                <form
                    className="fin-pp__card fin-pp__search"
                    style={{ marginBottom: 16, padding: '12px 16px' }}
                    onSubmit={(e) => { buscar(); e.preventDefault(); }}
                >
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            autoFocus
                            id="nome"
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome do local"
                            onChange={e => setFiltro({ ...filtro, nome: e.target.value })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                {podeExcluir && selectedArr.length === 1 && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                            onClick={() => excluirSelecionado(selectedArr[0])}
                        >
                            <ImCancelCircle size={14} /> Excluir
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>
                                        <input
                                            type="checkbox"
                                            checked={paginados.length > 0 && selectedIds.size === paginados.length}
                                            onChange={toggleAll}
                                        />
                                    </th>
                                    <th style={{ width: 60 }}></th>
                                    <th style={{ width: 80 }}>Situação</th>
                                    <th>Nome</th>
                                    <th>Endereço</th>
                                    <th>Município</th>
                                    <th>País</th>
                                    <th>CEP</th>
                                    <th>Bairro</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando ? (
                                    <tr><td colSpan={9} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : paginados.length === 0 ? (
                                    <tr><td colSpan={9} className="fin-pp__empty">Nenhum registro</td></tr>
                                ) : paginados.map(row => (
                                    <tr key={row.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.has(row.id)}
                                                onChange={() => toggleSelect(row.id)}
                                            />
                                        </td>
                                        <td>
                                            <Link to={"/cadastroLocal/" + row.id} className="fin-pp__rowbtn">
                                                <FaPen size={14} />
                                            </Link>
                                        </td>
                                        <td>
                                            <span className={`fin-pp__pill ${row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted'}`}>
                                                {row.situacaoRegistro}
                                            </span>
                                        </td>
                                        <td className="fin-pp__cell-strong">{row.nome}</td>
                                        <td className="fin-pp__cell-muted">{row.endereco}</td>
                                        <td className="fin-pp__cell-muted">
                                            {row.municipio_relacao
                                                ? row.municipio_relacao.nome + '-' + row.municipio_relacao.uf
                                                : row.municipioExterior ?? ""}
                                        </td>
                                        <td className="fin-pp__cell-muted">{row.pais_relacao?.nome}</td>
                                        <td className="fin-pp__cell-muted">{row.enderecocep}</td>
                                        <td className="fin-pp__cell-muted">{row.bairro}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
